import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SHIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SH" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          d="m-1.002 6.5 1.98.869L9.045.945 10.09-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.002 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-.731 7.108 1.009.504L9.715-.467H8.298L-.731 7.108Z"
        />
        <Path
          fill="#F7FCFF"
          d="M10.002 6.5 8.245 7.616-.045.944-1.09-.346l2.118-.291 3.29 2.768 2.649 1.866L10.002 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.935 6.936-1.01.504-4.018-3.459-1.19-.386L-1.19-.342H.227L5.13 3.502l1.303.463 3.502 2.971Z"
        />
        <Mask
          id="c"
          width={11}
          height={9}
          x={-1}
          y={-1}
          fill="#000"
          maskUnits="userSpaceOnUse"
        >
          <Path fill="#fff" d="M-1-1h11v9H-1z" />
          <Path
            fillRule="evenodd"
            d="M4.8 0H4v3.2H0V4h4v3.2h.8V4h4v-.8h-4V0Z"
            clipRule="evenodd"
          />
        </Mask>
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4.8 0H4v3.2H0V4h4v3.2h.8V4h4v-.8h-4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          d="M4 0v-.75h-.75V0H4Zm.8 0h.75v-.75H4.8V0ZM4 3.2v.75h.75V3.2H4Zm-4 0v-.75h-.75v.75H0ZM0 4h-.75v.75H0V4Zm4 0h.75v-.75H4V4Zm0 3.2h-.75v.75H4V7.2Zm.8 0v.75h.75V7.2H4.8Zm0-3.2v-.75h-.75V4h.75Zm4 0v.75h.75V4H8.8Zm0-.8h.75v-.75H8.8v.75Zm-4 0h-.75v.75h.75V3.2ZM4 0v.75h.8v-1.5H4V0Zm0 3.2h.75V0h-1.5v3.2H4Zm-4 0v.75h4v-1.5H0v.75ZM0 4h.75v-.8h-1.5V4H0Zm4 0v-.75H0v1.5h4V4Zm0 3.2h.75V4h-1.5v3.2H4Zm.8 0v-.75H4v1.5h.8V7.2Zm0-3.2h-.75v3.2h1.5V4H4.8Zm4 0v-.75h-4v1.5h4V4Zm0-.8h-.75V4h1.5v-.8H8.8Zm-4 0v.75h4v-1.5h-4v.75Zm0-3.2h-.75v3.2h1.5V0H4.8Z"
          mask="url(#c)"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
